import React, { useEffect, useContext, useState } from "react";
import apiClient from "../../../../api/Api.js";
import { DataContext } from "../../../../context/dataprovider.js";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
const StatusProjectCount = ({ fromDate, toDate, projectId }) => {
  const {
    userData = {},
    loading,
    statusDef,
    statusColors,
  } = useContext(DataContext);

  const Analysis_api = process.env.REACT_APP_ANALYTICS;

  const [transactionData, setTransactionData] = useState({});
  const [tableLoading, setTableLoading] = useState(true);

  // Dynamically get the list of statuses
  const statuses = Object.values(statusDef); // ["Submitted", "Approved", ...]

  const getStatusProjectCountData = async () => {
    try {
      const response = await apiClient.post(
        `${Analysis_api}/get_status_project_count`,
        {
          projectId: projectId,
          fromDate: fromDate,
          toDate: toDate,
        }
      );
      const rawData = response.data.data;
      setTransactionData(rawData);
    } catch (error) {
      console.error("Error in Transaction Analysis:", error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    if (!loading && projectId && projectId.length > 0) {
      getStatusProjectCountData();
    }
  }, [loading, projectId, fromDate, toDate]);

  const renderTable = () => {
    return (
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Project ID</strong>
              </TableCell>
              {statuses.map((status) => {
                return (
                  <TableCell key={status} align="center">
                    {status}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(transactionData).map(([project, data]) => (
              <TableRow key={project}>
                <TableCell component="th" scope="row">
                  {project}
                </TableCell>
                {statuses.map((status) => {
                  const value = data[status] || 0;

                  return (
                    <TableCell key={status} align="center">
                      {value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        Transactions Table Analysis
      </Typography>
      {renderTable()}
    </div>
  );
};

export default StatusProjectCount;
